import dayjs from 'dayjs';
import getOffsetTime from '../../../../../utils/getOffsetTime.js';


const editTour = (itemDetails, optimisticLiveSchedule, dayTypesAllowTour, resourceId) => {
  const { tourId, rdtId, dayTypeId, tourStartTime, tourEndTime, mealStartTime } = itemDetails;
  const { notification, comment, comment15  } = itemDetails.tourParams;
  // const { mealId, mealStart, mealEnd, } = itemDetails.tourDetails.meals[0];
  const tempRdtId = `${rdtId}-optimistic`;
  const tempTourId = `${tourId}-optimistic`;
  // const tempMealId = `${mealId}-optimistic`;

  let startTime = dayjs(tourStartTime);
  let timeZoneOffset = getOffsetTime(startTime);
  // console.log(`rdtId: ${rdtId}`); // debug
  // console.log(`tourId: ${tourId}`); // debug
  // console.log(timeZoneOffset); // debug
  
  // console.log(startTime); // debug
  startTime = startTime.subtract(timeZoneOffset, 'minute').unix();
  // let mealTime = dayjs(mealStartTime).clone().add(4, 'hour').unix();
  // create new dayType, tour and meal
  const tour = {
    tourId: tempTourId,
    startTime,
    duration: dayjs(tourEndTime).diff(dayjs(tourStartTime),'hour'),
    notificationComment: notification,
    tourComment: comment,
    myTourComment: comment15,
    tourIndicators: [],
    tourPayTransactions: [],
    // meal: {
    //   mealId: tempMealId,
    //   mealTime,
    //   red: false
    // },
    assignments: {}
  };
  // build new resource obj which will house dayTypes array, which houses tour obj
  const origResource = optimisticLiveSchedule.find((elem) => resourceId == elem.rId);
  const resource = JSON.parse(JSON.stringify(origResource));
  if (resource.dayTypes[rdtId]) {
    // create and populate new dayType
    resource.dayTypes[tempRdtId] = {};
    resource.dayTypes[tempRdtId].rdtId = tempRdtId;
    resource.dayTypes[tempRdtId].dayTypeId = dayTypeId
    resource.dayTypes[tempRdtId].title = dayTypesAllowTour.find((elem) => elem.id == dayTypeId).name;
    resource.dayTypes[tempRdtId].tour = tour;
    // *** NEW *** copy existing assignments (if any)
    if (resource.dayTypes[rdtId].tour) {
      resource.dayTypes[tempRdtId].tour.assignments = resource.dayTypes[rdtId].tour.assignments;
    }
    // delete old dayType
    delete resource.dayTypes[rdtId];
  }
  return resource;
}

export default editTour;
